/**
 * Rendered height of an element, rounded up so a fractional layout never gets cut off.
 *
 * @param {HTMLElement|null|undefined} element
 * @returns {number}
 */
export default function measureHeight(element) {
    return element ? Math.ceil(element.getBoundingClientRect().height) : 0;
}
